"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MessageTextContentNative = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
exports.MessageTextContentNative = react_1["default"].memo(function MessageTextContentNative(props) {
    var _a;
    return ((0, jsx_runtime_1.jsx)(react_native_1.Text, __assign({ style: { color: 'white', width: '100%', fontFamily: "hiyllo" } }, { children: (_a = props.content.text) !== null && _a !== void 0 ? _a : '' })));
});
